import { render, staticRenderFns } from "./cookie-categories-card.vue?vue&type=template&id=0d2ab31f"
import script from "./cookie-categories-card.vue?vue&type=script&lang=js"
export * from "./cookie-categories-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports